import { h } from "preact";
import SwatchDetailsBody from "./swatch-details-body";

// Mirrors the 'media-bg-class' snippet: a still that already ships on grey
// keeps the backdrop but drops the blend, which would otherwise double it.
const isOnGrey = (url) => url.toLowerCase().includes("ongrey");

export default function SwatchDetailsSummary({
  item,
  variantImage,
  details,
  detailsLoading,
}) {
  if (!item) return null;

  return (
    <div className="swatch-details-drawer__summary">
      <div className="swatch-details-drawer__summary-media">
        {variantImage && (
          <div
            className={`swatch-details-drawer__summary-product-media${
              isOnGrey(variantImage.url)
                ? " swatch-details-drawer__summary-product-media--no-blend"
                : ""
            }`}
          >
            <img
              className="swatch-details-drawer__summary-product-image"
              src={window.getSizedImageUrl(variantImage.url, "600x")}
              alt=""
              loading="lazy"
            />
          </div>
        )}
        {item.image ? (
          <img
            className="swatch-details-drawer__summary-image"
            src={window.getSizedImageUrl(item.image.url, "600x")}
            alt=""
            loading="lazy"
          />
        ) : (
          <div className="swatch-details-drawer__summary-image swatch-details-drawer__summary-image--placeholder"></div>
        )}
      </div>
      <div className="swatch-details-drawer__summary-info">
        <div className="swatch-details-drawer__summary-heading">
          {item.materialGroup && (
            <div className="swatch-details-drawer__eyebrow">
              {item.materialGroup}
            </div>
          )}
          <h3 className="swatch-details-drawer__swatch-title">
            {item.optionValueName}
          </h3>
        </div>
        <SwatchDetailsBody
          key={item.swatchProduct?.gid || item.optionValueName}
          details={details}
          loading={detailsLoading}
        />
      </div>
    </div>
  );
}
